module.exports = __webpack_public_path__ + "5b66c02790301f40128234999e48277a.jpg";